import { RHFTextField } from '@aibees/shared/components';
import { useNotify } from '@aibees/shared/hooks';
import { classnames, formatPriceNumber } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo, useState } from 'react';
import { config } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { CreditCapDialogProps as Props } from './types';

export const CreditCapDialog = memo(({ className, item, onClose }: Props) => {
  const [creditCap, setCreditCap] = useState<string>();
  const { success } = useNotify();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCreditCap(formatPriceNumber(+e.target.value.replaceAll(',', '')));
  };

  const handleSubmit = () => {
    success('Credit Cap Has Been Set.');
    onClose?.();
  };

  return (
    <Styled.Wrapper
      {...config}
      submitButtonProps={{
        children: 'Add',
      }}
      // scheme={scheme}
      defaultOpen
      defaultValues={{ type: item.type }}
      onClose={onClose}
      onSubmit={handleSubmit}
      contentSx={SX.content}
      // hideCloseIconInHeader
      className={classnames('CreditCapDialog', className)}
      sx={SX.root}
      maxWidth="sm"
      fullWidth
    >
      <Typography sx={SX.label}>Credit</Typography>
      <RHFTextField
        name="creditCap"
        value={creditCap}
        onChange={handleChange}
        InputProps={{ sx: SX.input }}
      />
    </Styled.Wrapper>
  );
});

CreditCapDialog.displayName = 'CreditCapDialog';
